import React, { useState } from 'react';
import alertIcon from '../../assets/images/not confirmed.svg';
import arrowIcon from '../../assets/images/arrow-gray.svg';
import Loading from '~/components/layout/Loading';
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  BackButton,
  ModalTitle,
  AlertIcon,
  ModalContent,
  ModalMessage,
  TextAreaContainer,
  TextArea,
  CharacterCounter,
  ButtonContainer,
  SendButton,
  ValidationMessageError,
  ValidationMessageInfo
} from './styles';

const VisitNotConfirmedModal = ({
  isOpen,
  onClose,
  onBack,
  onSubmit
}) => {
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const maxCharacters = 250;

  if (!isOpen) return null;

  const isCommentValid = comment.length >= 10;

  const handleSubmit = async () => {
    if (!isCommentValid) return;
    setIsLoading(true);
    if (onSubmit) {
      try {
        await onSubmit(comment);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCommentChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxCharacters) {
      setComment(value);
    }
  };

  return (
    <ModalOverlay>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          {onBack && (
            <BackButton onClick={onBack}>
              <img src={arrowIcon} alt="Voltar" />
              Voltar
            </BackButton>
          )}
          </ModalHeader>

        <AlertIcon>
          <img src={alertIcon} alt="Alerta" />
        </AlertIcon>

        <ModalTitle>Visita não realizada</ModalTitle>

        <ModalContent>
          <ModalMessage>
            Obrigado por informar. Adicione um comentário para nos ajudar a entender melhor.
          </ModalMessage>

          <TextAreaContainer>
            <TextArea
              placeholder="Adicione um comentário"
              value={comment}
              onChange={handleCommentChange}
              disabled={isLoading}
            />
            <CharacterCounter>
              {comment.length}/{maxCharacters}
            </CharacterCounter>
          </TextAreaContainer>

          {comment.length > 0 && comment.length < 10 && (
            <ValidationMessageError>
              Mínimo de 10 caracteres para enviar ({comment.length}/10)
            </ValidationMessageError>
          )}

          {comment.length === 0 && (
            <ValidationMessageInfo>
              Mínimo de 10 caracteres para enviar
            </ValidationMessageInfo>
          )}

          <ButtonContainer>
            <SendButton onClick={handleSubmit} disabled={!isCommentValid || isLoading}>
              Enviar
            </SendButton>
          </ButtonContainer>
        </ModalContent>
      </ModalContainer>

      {isLoading && (
        <div aria-hidden style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
          <Loading />
        </div>
      )}
    </ModalOverlay>
  );
};

export default VisitNotConfirmedModal;
